import React, { Component } from 'react';
import { connect } from 'react-redux';

import CSS from './styles.css';
import { sortNotebookAnnotations } from 'PipeRouter';
import {  CaretDown as CDIcon } from 'Shared/Icons';

const Fragment = React.Fragment;
const keys = {
  tab:    9,
  enter:  13,
  esc:    27,
  space:  32,
  left:   37,
  up:     38,
  right:  39,
  down:   40,
  shift:  16
};

//how to display?
class SortByMenu extends Component {
  constructor(props) {
    super(props);
  }

  onSortOrderChange = event => {
    const { target } = event;
    const order = target.textContent;
    const parent = target.parentElement.parentElement;
    const { sortNotebookAnnotations, sortOrder } = this.props;

    if (sortOrder !== order) {
      sortNotebookAnnotations(order);
    }

    parent.focus();
  };

  openMenu = event => {
    let isExpanded = event.currentTarget.getAttribute('aria-expanded');

    isExpanded = isExpanded === 'false'
      ? false
      : true;

    event.currentTarget.setAttribute('aria-expanded', !isExpanded);
    event.preventDefault();
    event.stopPropagation();
  };

  renderMenu = () => {
    return (
      <div className={ CSS['menu-container'] }>
        <ul role="menu" className={ CSS['list'] } tabIndex="0">
          <li className={ CSS['list-item'] } onClick={ this.onSortOrderChange } tabIndex="-1">Newest</li>
          <li className={ CSS['list-item'] } onClick={ this.onSortOrderChange } tabIndex="-1">Oldest</li>
        </ul>
      </div>
    );
  };

  onMenuItemKeyDown = event => {
    const { currentParentIndex, goToNextMenuFromSubmenu } = this.props;
    const { keyCode, target } = event;
    const { nextElementSibling, previousElementSibling, parentNode } = target;
    const menuItems = parentNode.children;
    const firstMenuItem = menuItems[0];
    const miLen = menuItems.length;
    const lastMenuItem = menuItems[miLen - 1];

    if (keyCode === keys.tab) {
      if (event.shiftKey) {
        const parent = target.parentElement.parentElement;
        parent.setAttribute('aria-expanded', false);
        goToNextMenuFromSubmenu(parent, currentParentIndex - 1);
        event.preventDefault();
        event.stopPropagation();
      } else {
        const parent = target.parentElement.parentElement;
        parent.setAttribute('aria-expanded', false);
        goToNextMenuFromSubmenu(parent, currentParentIndex + 1);
        event.preventDefault();
        event.stopPropagation();
      }
    }

    if (keyCode === keys.esc) {
      const parent = target.parentElement.parentElement;
      parent.setAttribute('aria-expanded', false);
      parent.focus();
    }

    if (keyCode === keys.down) {
      if (nextElementSibling) {
        nextElementSibling.focus();
        event.preventDefault();
        event.stopPropagation();
      } else {
        firstMenuItem.focus();
        event.preventDefault();
        event.stopPropagation();
      }
    }

    if (keyCode === keys.up) {
      if (previousElementSibling) {
        previousElementSibling.focus();
        event.preventDefault();
        event.stopPropagation()
        return false;
      } else {
        lastMenuItem.focus();
        event.preventDefault();
        event.stopPropagation()
        return false;
      }
    }

    if (keyCode === keys.right) {
      const parent = target.parentElement.parentElement;
      parent.setAttribute('aria-expanded', false);
      goToNextMenuFromSubmenu(parent, currentParentIndex + 1);
      event.preventDefault();
      event.stopPropagation();
    }

    if (keyCode === keys.left) {
      const parent = target.parentElement.parentElement;
      parent.setAttribute('aria-expanded', false);
      goToNextMenuFromSubmenu(parent, currentParentIndex - 1);
      event.preventDefault();
      event.stopPropagation();
    }

    if (keyCode === keys.enter || keyCode === keys.space) {
      event.target.parentElement.parentElement.setAttribute('aria-expanded', false);
      this.onSortOrderChange(event);
      event.preventDefault();
      event.stopPropagation();
    }
  };

  onMenuKeyDown = event => {
    const { currentParentIndex, goToNextMenu, goToNextMenuFromSubmenu, updateParentIndex } = this.props;
    const { keyCode, target } = event;
    const menus = target.parentElement.getElementsByClassName('menu');
    const mLen = menus.length;

    if (keyCode === keys.up) {
      const menu = target.querySelector('ul');

      if (menu.children.length > 0) {
        const listItems = menu.querySelectorAll('li');
        target.setAttribute('aria-expanded', true);
        listItems[listItems.length-1].focus();
      }
    }

    if (keyCode === keys.down || keyCode === keys.space || keyCode === keys.enter) {
      const menu = target.querySelector('ul');

      if (menu.children.length > 0) {
        const listItems = menu.querySelectorAll('li');
        target.setAttribute('aria-expanded', true);
        listItems[0].focus();
      }
    }

    if (keyCode === keys.tab) {
      if (event.shiftKey) {
        if (currentParentIndex - 1 < 0) {
          updateParentIndex(0);
        } else {
          goToNextMenu(target, currentParentIndex - 1);
          event.preventDefault();
        }
      } else {
        if (currentParentIndex === mLen-1) {
          updateParentIndex(mLen-1);
        } else {
          goToNextMenu(target, currentParentIndex + 1);
          event.preventDefault();
        }
      }
    }

    if (keyCode === keys.right) {
      if (currentParentIndex === mLen - 1) {
        goToNextMenu(target, 0);
        event.preventDefault();
      } else {
        goToNextMenu(target, currentParentIndex + 1);
        event.preventDefault();
      }
    }

    if (keyCode === keys.left) {
      if (currentParentIndex === 0) {
        goToNextMenu(target, mLen - 1);
        event.preventDefault();
      } else {
        goToNextMenu(target, currentParentIndex - 1);
        event.preventDefault();
      }
    }
  };

  render() {
    const { sortOrder } = this.props;

    return (
      <Fragment>
        <span className={ CSS['filter_title'] }>Sort by:</span>
        <li id="sortBy" className={`menu ${CSS['menu']}`} role="menuitem" aria-haspopup="true" aria-expanded="false" onKeyDown={ this.onMenuKeyDown } onClick={ this.openMenu } tabIndex="0">
          <span className={ CSS['filter_subTitle'] }>{ sortOrder }</span>
          <CDIcon width="8px" height="6px" viewBox="0 0 8 6" fill="#00758e" />
          <ul role="menu" className={ CSS['submenu'] }>
            <li role="menuitem" tabIndex="-1" className={ CSS['list-item'] } onKeyDown={ this.onMenuItemKeyDown } onClick={ this.onSortOrderChange }>
              <span className={ CSS['text'] }>Newest</span>
            </li>
            <li role="menuitem" tabIndex="-1" className={ CSS['list-item'] } onKeyDown={ this.onMenuItemKeyDown } onClick={ this.onSortOrderChange }>
              <span className={ CSS['text'] }>Oldest</span>
            </li>
          </ul>
        </li>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { notebook:{ sortOrder }} = state;
  return { sortOrder };
}


export default connect(mapStateToProps, {
  sortNotebookAnnotations
})(SortByMenu);
